<template>
  <v-app class="pa-2" v-show="!progress || menu">
    <v-container class="pl-8 pr-8 pb-0" v-if="menu">
      <v-row justify="center">
        <v-col cols="auto">
          <v-avatar size="200" tile>
            <ImgWrapper :src="menu.t_image_url" v-if="menu.t_image_url" />
            <ImgWrapper :src="noimageUrl" v-else />
          </v-avatar>
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <!-- メニュー名 -->
        <v-col cols="11" align="center" class="pt-0 pb-0">
          <span class="text-h5">{{ menu.name }}</span>
        </v-col>
        <!-- 質問(メニュー本体) -->
        <v-col
          v-if="isShowHelp(menu.help)"
          cols="1"
          align="right"
          class="pr-0 pt-0 pb-0"
        >
          <span>
            <v-icon @click.stop="showHelp(menu.help)"
              >fas fa-question-circle</v-icon
            >
          </span>
        </v-col>
      </v-row>
      <!-- 売切表示 -->
      <v-row
        justify="center"
        align="center"
        class="pt-0"
        v-if="isSoldOut(menu)"
      >
        <v-col align="center">
          <span class="text-h6 red--text">完売</span>
        </v-col>
      </v-row>
    </v-container>

    <!-- ふきだし -->
    <v-container v-show="!progress && bubbleContent" class="pl-4 pr-4">
      <v-row>
        <v-col class="pt-0">
          <Bubble :content="bubbleContent" />
        </v-col>
      </v-row>
    </v-container>

    <v-container class="pl-8 pr-8" v-if="menu">
      <!-- トッピング群 -->
      <v-row v-for="topping in menu.toppings" :key="topping.id">
        <v-col cols="11" class="pa-0 pl-4">
          <v-select
            :items="createToppingValues(topping.values)"
            :label="topping.name"
            item-value="id"
            item-text="name"
            item-disabled="disabledValue"
            outlined
            v-model="topping.selected"
          >
            <!-- 表示文字列(選択状態)-->
            <template v-slot:selection="data1">
              <span>
                {{ data1.item.name }}
              </span>
            </template>
            <!-- 表示文字列(プルダウン展開中)-->
            <template v-slot:item="data2">
              <v-row justify="space-between" no-gutters>
                <v-col cols="9" class="pa-0 text-body-2" align="left">
                  {{ data2.item.name }}
                </v-col>
                <v-col
                  v-if="!data2.item.disabledValue"
                  class="pa-0 text-body-2"
                  align="right"
                >
                  {{ toppingAmountText(data2.item.amount) }}
                </v-col>
                <v-col v-else class="pa-0 text-body-2 red--text" align="right">
                  完売
                </v-col>
              </v-row>
            </template>
          </v-select>
        </v-col>

        <!-- 質問(トッピング) -->
        <v-col cols="1" class="pt-4 pr-0" align="right">
          <span v-if="isShowHelp(topping.help)">
            <v-icon @click.stop="showHelp(topping.help)"
              >fas fa-question-circle</v-icon
            >
          </span>
        </v-col>
      </v-row>
    </v-container>

    <!-- 個数 -->
    <v-container class="pt-0 pl-8 pr-8 pb-0" v-if="menu">
      <v-row>
        <v-col cols="11" class="pa-0 pl-4">
          <v-select
            v-model="menuCount"
            :items="menuCounts"
            label="個数"
            outlined
            class="pt-0 mt-0"
          >
            <template v-slot:selection="data">
              <span class="d-flex justify-center" style="width: 100%">
                {{ data.item }}
              </span>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-container>

    <!-- 金額 -->
    <v-container class="pt-0 pr-8" v-if="menu">
      <v-row justify="end" align-content="center" align="center">
        <!-- <v-col cols="auto" v-if="menu.discountStatus === 1">
          <v-chip color="red" text-color="white"> 割引中 </v-chip>
        </v-col> -->
        <v-col cols="auto" class="pr-0">
          <span class="text-h3">￥</span>
          <span class="text-h2">{{ amountMenu(menu) | addComma }}</span>
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-col cols="auto" class="pt-0 pr-0">
          <span class="text-h7">( 税込 )</span>
          <!-- <span class="text-h7">( 内消費税等 ￥</span>
          <span class="text-h7">17</span>
          <span class="text-h7"> )</span> -->
        </v-col>
      </v-row>
    </v-container>

    <!-- ボタン -->
    <v-container fluid v-if="menu">
      <!-- カートに追加/更新 -->
      <v-row justify="center">
        <v-col cols="12">
          <v-btn
            v-if="from == 'cart'"
            :disabled="isSoldOut(menu)"
            x-large
            block
            tile
            text
            outlined
            @click="addCart(menu)"
            >カートを更新</v-btn
          >
          <v-btn
            v-else
            :disabled="isSoldOut(menu)"
            x-large
            block
            tile
            text
            outlined
            @click="addCart(menu)"
            >カートに追加する</v-btn
          >
        </v-col>
      </v-row>
    </v-container>

    <!-- sheet -->
    <v-bottom-sheet v-if="help" v-model="sheet" inset>
      <v-sheet class="text-center">
        <v-container class="line-bg">
          <v-row>
            <v-col>
              <Bubble
                :question="help.question"
                :content="help.answer"
                :border-content="false"
              />
            </v-col>
          </v-row>

          <v-btn x-large text class="mt-4" @click="sheet = !sheet"
            ><span class="text-decoration-underline white--text"
              >メニューへもどる</span
            ></v-btn
          >
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="sheet_cart" inset>
      <v-sheet class="text-center">
        <v-container class="line-bg">
          <v-row>
            <v-col>
              <Bubble
                :content="bubbleContentCartAdded"
                :border-content="false"
              />
            </v-col>
          </v-row>
          <div class="mt-8 mb-8">
            <QuickReply
              text="他にも注文する"
              class="ma-2"
              :click="onClickToMenu"
            />
            <QuickReply
              text="カートへすすむ"
              bgColor="#ff8a65"
              :click="onClickToCart"
            />
          </div>
          <!-- 下部固定 -->
          <div style="align: center; width: 100%">
            <v-btn x-large text @click="sheet_cart = !sheet_cart"
              ><span class="text-decoration-underline white--text"
                >メニューへもどる</span
              ></v-btn
            >
          </div>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!-- sheet エラー(メニュー一覧へ遷移) -->
    <v-bottom-sheet v-model="showSheetReload" persistent>
      <v-sheet class="text-center">
        <v-container class="line-bg">
          <v-row>
            <v-col>
              <Bubble :content="errorSheetReloadText" :border-content="false" />
            </v-col>
          </v-row>
          <div class="mt-8 mb-8">
            <QuickReply
              text="メニュー一覧へ"
              class="ma-2"
              :click="onClickToReload"
            />
          </div>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!-- sheet エラー(共通) -->
    <v-bottom-sheet v-model="showErrorCmnSheet" persistent>
      <v-sheet class="text-center">
        <v-container class="line-bg">
          <v-row>
            <v-col>
              <Bubble :content="errorSheetCmnText" :border-content="false" />
            </v-col>
          </v-row>
          <v-btn
            x-large
            text
            class="mt-4"
            @click="showErrorCmnSheet = !showErrorCmnSheet"
            ><span class="text-decoration-underline white--text"
              >メニューへもどる</span
            ></v-btn
          >
        </v-container>
      </v-sheet>
    </v-bottom-sheet>

    <!-- snackbar -->
    <v-snackbar v-model="snackbar" :timeout="timeout" :multi-line="true">
      {{ snackbarText }}
    </v-snackbar>
  </v-app>
</template>

<script>
import liff from "@line/liff";
import { mapGetters, mapActions } from "vuex";
import { MSG_TYPE, commonError } from "../components/error/errorConstants";
import Bubble from "./parts/Bubble";
import QuickReply from "./parts/QuickReply";
import { calculate } from "../util/calculate";
const IMAGE_DEFAULT = require("@/assets/noimage.png");
import { PROVIDE_STATUS } from "../constants/order_constants";
import { MSG_MENU } from "../constants/messages";

import {
  CHECK_TYPE,
  createCheckErrMsg,
  isSoldOutMenu,
} from "../util/order_util";

// エラーシート
const SHEET_ERR_CMN = 0;
const SHEET_ERR_TO_MENULIST = 1;

// from (画面遷移元)
//   空: メニュー一覧
//   cart: カートで編集押下
//   history: 注文履歴で「もういちど注文」押下
const FROM_MENULIST = "";
const FROM_CART = "cart";
const FROM_HISTORY = "history";

export default {
  components: {
    Bubble,
    QuickReply,
    ImgWrapper: () => import("./parts/ImgWrapper"),
  },
  name: "Menu",
  props: {},
  data: () => ({
    bubbleContent: "",
    noimageUrl: IMAGE_DEFAULT,
    // 画面遷移元
    from: FROM_MENULIST,
    menu: null,
    // メニュー数量
    menuCount: 0,
    menuCounts: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    help: null,
    // snackbar
    snackbar: false,
    timeout: 2000,
    snackbarText: "",
    // bottom sheet
    sheet: false,
    // bottom sheet (cart)
    sheet_cart: false,
    bubbleContentCartAdded:
      "ありがとうございます！\nカートに追加しました。\n以上でよろしいですか？",
    // bottom sheet
    showErrorCmnSheet: false,
    errorSheetCmnText: "",
    showSheetReload: false,
    errorSheetReloadText: "",
  }),
  created() {
    this.$store.state.appBar = true;
    this.$store.state.title = "メニュー";
    this.$store.state.cart = true;

    // 画面遷移元
    const from = this.$route.query.from;
    this.from = from ? from : FROM_MENULIST;
  },
  computed: {
    ...mapGetters(["progress", "userId"]),
    amountMenu: function () {
      return function (menu) {
        return this.calculateMenuAmount(menu);
      };
    },
    toppingAmountText: function () {
      return function (amount) {
        let amountText = "";
        if (amount < 0) {
          amountText = this.$options.filters.addComma(Number(amount));
        } else if (amount == 0) {
          amountText = "";
        } else if (0 < amount) {
          amountText = "+" + this.$options.filters.addComma(Number(amount));
        }
        return amountText;
      };
    },
  },
  watch: {},
  async mounted() {
    await liff.ready; // LIFF 初期化待機
    this.showProgress();

    try {
      this.menu = await this.fetchData();
      this.bindData();
    } catch (error) {
      console.log(error);
      const msgType = MSG_TYPE.LOAD;
      this.$router.replace({ name: "Error", query: { msgType: msgType } });
    } finally {
      this.hideProgress();
    }
  },
  methods: {
    ...mapActions([
      "showProgress",
      "hideProgress",
      "fetchMenu",
      "checkBeforeMenuAction",
    ]),
    ...mapActions("rest", [
      "addCartMenu",
      "editCartMenu",
      "fetchMenuForCart",
      "fetchMenuForHistory",
    ]),
    fetchData: async function () {
      const id = this.$route.params.id;
      return this.findMenu(id);
    },
    bindData: function () {
      // ふきだし
      const bubbleContent = this.createBubbleContent();
      if (bubbleContent) {
        this.bubbleContent = bubbleContent;
      }

      // 選択数
      if (this.from === FROM_MENULIST) {
        this.menuCount = 1;
      } else {
        this.menuCount = this.menu.count;
      }
    },
    findMenu: async function (id) {
      if (this.from === FROM_MENULIST) {
        return this.fetchMenu({ id });
      } else if (this.from === FROM_CART) {
        return this.findMenuForCart(); // カート
      } else if (this.from === FROM_HISTORY) {
        return this.findMenuForHistory(); // 注文履歴
      } else {
        throw Error(`not implemented: ${this.from}`);
      }
    },
    findMenuForCart: async function () {
      // カート
      const cartMenuId = this.$route.query.cartMenuId;
      return this.fetchMenuForCart({ cartMenuId });
    },
    findMenuForHistory: async function () {
      // 注文履歴
      const orderId = this.$route.query.orderId;
      const orderMenuId = this.$route.query.orderMenuId;
      // console.log("orderId", orderId, "orderMenuId", orderMenuId);
      return this.fetchMenuForHistory({ orderId, orderMenuId });
    },
    createBubbleContent: function () {
      const text = this.menu?.about ?? "このメニューは存在しません";
      return text;
    },
    isSoldOut: function (menu) {
      return isSoldOutMenu(menu);
    },
    createToppingValues: function (values) {
      const newValues = values.map((v) => {
        v.disabledValue = this.isNotProvideToppingValue(v);
        return v;
      });
      return newValues;
    },
    isNotProvideToppingValue: function (value) {
      // console.log("@isNotProvideToppingValue", value);
      // 「提供可能」以外
      const provideStatus = value.provideStatus;
      if (!Number.isSafeInteger(provideStatus)) {
        return false; // 未定義は「提供可能」扱い (default)
      }
      return provideStatus !== PROVIDE_STATUS.PROVIDED;
    },
    addCart: async function (menu) {
      this.showProgress();
      try {
        return await this.addCartProcess(menu); // 呼び出し元で await していないのでここで await かける
      } catch (e) {
        console.error(e);
        this.showErrorSheetCommon();
      } finally {
        this.hideProgress();
      }
    },
    addCartProcess: async function (menu) {
      const rest = this.from != FROM_MENULIST; // メニュー一覧以外は REST データ
      const beforeCheckResult = await this.checkBeforeMenuAction({
        menu,
        rest,
      });
      if (!beforeCheckResult.result) {
        const checkType = beforeCheckResult.type;
        const sheetType = this.getErrorSheetType(checkType);

        let msg = "";
        if (checkType === CHECK_TYPE.MST_MENU_CHANGED) {
          msg = MSG_MENU.CHANGED;
        } else {
          msg = createCheckErrMsg(checkType);
        }
        this.showErrorSheet(sheetType, msg);
        return;
      }

      // 入力値 反映
      menu.count = this.menuCount;

      // DBに反映
      if (this.from == FROM_CART) {
        // 更新
        await this.editCartMenu({ menu });
      } else {
        // 新規追加
        await this.addCartMenu({ menu });
      }

      // カートアイコン (必ずアニメーションさせる)
      // this.$store.state.cartDoAnimate = true;

      // カート内アイテム数 更新
      // this.fetchCartItemSize();

      // snackbar 表示
      // this.snackbarText =
      //   this.from == "cart" ? "カートを更新しました" : "カートに追加しました";
      // this.snackbar = true;

      // カート追加 -> シート表示
      // カート更新 -> 画面遷移(カート)
      if (this.from == FROM_CART) {
        // 更新
        this.$router.push({ name: "Cart" });
      } else {
        // 新規追加
        this.sheet_cart = !this.sheet_cart;
      }
    },
    showErrorSheet: function (type, msg) {
      switch (type) {
        case SHEET_ERR_CMN:
        default:
          this.errorSheetCmnText = msg;
          this.showErrorCmnSheet = !this.showErrorCmnSheet;
          break;
        case SHEET_ERR_TO_MENULIST:
          this.errorSheetReloadText = msg;
          this.showSheetReload = !this.showSheetReload;
          break;
      }
    },
    getErrorSheetType: function (checkType) {
      switch (checkType) {
        case CHECK_TYPE.MST_MENU_CHANGED:
        case CHECK_TYPE.MST_MENU_DELETED:
          return SHEET_ERR_TO_MENULIST;
        default:
          return SHEET_ERR_CMN;
      }
    },
    calculateMenuAmount: function (menu) {
      menu.count = this.menuCount; //一時的に選択値で上書き
      return calculate.calcMenuPrice(menu);
    },
    isShowHelp: function (help) {
      if (!help || !help.question || !help.answer) {
        return false;
      }
      return true;
    },
    showHelp: function (help) {
      this.help = help;
      this.sheet = !this.sheet;
    },
    incrementMenuCount: function (add) {
      const MENU_COUNT_MIN = 1;
      const MENU_COUNT_MAX = 5;
      if (add) {
        if (this.menuCount < MENU_COUNT_MAX) {
          this.menuCount = this.menuCount + 1;
        }
      } else {
        if (MENU_COUNT_MIN < this.menuCount) {
          this.menuCount = this.menuCount - 1;
        }
      }
    },
    onClickToMenu: function () {
      this.$router.push({ name: "MenuList" });
    },
    onClickToCart: function () {
      this.$router.push({ name: "Cart" });
    },
    onClickToReload: function () {
      this.$router.push({ name: "MenuList" });
    },
    showErrorSheetCommon: function () {
      this.showErrorCmnSheet = !this.showErrorCmnSheet;
      const message = commonError.findMessage(MSG_TYPE.SHEET_UPDATE);
      this.errorSheetCmnText = message.text;
    },
  },
};
</script>

<style scoped>
@import "../css/bubble.css";
</style>
<style scoped>
.soldout_box {
  position: relative;
  width: 100%;
  height: 60px;
}
.soldout_box span {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  /* 改行させない */
  white-space: nowrap;
}
.soldout_box img {
  height: 60px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}
</style>
